export function getBarcodeImage(item) {
  if (!item) return ''

  const candidates = []
  if (Array.isArray(item.barcodes)) candidates.push(...item.barcodes)
  if (item.barcode) candidates.push(item.barcode)
  if (!candidates.length) candidates.push(item)

  for (const b of candidates) {
    if (!b) continue

    if (typeof b === 'string') {
      if (/^(https?:|data:image\/)/.test(b)) return b
      continue
    }

    if (b.media) {
      const url = b.media.url || b.media.content
      if (url) return url
    }

    const direct = b.url || b.content
    if (direct) return direct
  }

  return ''
}